import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import StorageExhaustionError from './StorageExhaustionError';
var LocalStorageLimits = /*#__PURE__*/_createClass(function LocalStorageLimits() {
  var _this = this;
  _classCallCheck(this, LocalStorageLimits);
  _defineProperty(this, "STORAGE_CHAR_LIMIT", 4096);
  // IMS minimum storage limit is 4096 bytes so 4096 chars is more than enough
  _defineProperty(this, "STORAGE_KEY_LIMIT", 500);
  _defineProperty(this, "changeKeyCount", function (tool_id, value) {
    _this.limits.set(tool_id, {
      charCount: _this.limits.get(tool_id).charCount,
      keyCount: _this.limits.get(tool_id).keyCount + value
    });
  });
  _defineProperty(this, "changeCharCount", function (tool_id, value) {
    _this.limits.set(tool_id, {
      charCount: _this.limits.get(tool_id).charCount + value,
      keyCount: _this.limits.get(tool_id).keyCount
    });
  });
  _defineProperty(this, "createLimit", function (tool_id) {
    if (!_this.limits.get(tool_id)) {
      _this.limits.set(tool_id, {
        keyCount: 0,
        charCount: 0
      });
    }
  });
  _defineProperty(this, "getLimit", function (tool_id) {
    _this.createLimit(tool_id);
    return _this.limits.get(tool_id);
  });
  _defineProperty(this, "clearLimit", function (tool_id) {
    _this.limits["delete"](tool_id);
  });
  _defineProperty(this, "addToLimit", function (tool_id, key, value) {
    _this.createLimit(tool_id);
    var length = key.length + value.length;
    if (_this.limits.get(tool_id).keyCount >= _this.STORAGE_KEY_LIMIT) {
      throw new StorageExhaustionError('Reached key limit for tool');
    }
    if (_this.limits.get(tool_id).charCount + length > _this.STORAGE_CHAR_LIMIT) {
      throw new StorageExhaustionError('Reached byte limit for tool');
    }
    _this.changeKeyCount(tool_id, 1);
    _this.changeCharCount(tool_id, length);
  });
  _defineProperty(this, "removeFromLimit", function (tool_id, key, value) {
    _this.changeKeyCount(tool_id, -1);
    _this.changeCharCount(tool_id, -key.length - value.length);
    if (_this.limits.get(tool_id).keyCount < 0) {
      _this.limits.set(tool_id, {
        keyCount: 0,
        charCount: _this.limits.get(tool_id).charCount
      });
    }
    if (_this.limits.get(tool_id).charCount < 0) {
      _this.limits.set(tool_id, {
        keyCount: _this.limits.get(tool_id).keyCount,
        charCount: 0
      });
    }
  });
  this.limits = new Map();
});
export var localStorageLimits = new LocalStorageLimits();